import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function SAVE1Icon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M8.6 4.944H3.92c-.672 0-1.008 0-1.265.134-.226.117-.41.304-.524.534C2 5.873 2 6.215 2 6.9v2.2c0 .685 0 1.027.13 1.288.116.23.3.417.525.534.257.134.593.134 1.265.134H8.6M11 4.944h1.08c.672 0 1.008 0 1.265.134.226.117.41.304.524.534C14 5.873 14 6.215 14 6.9v2.2c0 .685 0 1.027-.13 1.288a1.2 1.2 0 0 1-.525.534c-.257.134-.593.134-1.265.134H11m0 2.444v-11m1.5 0h-3m3 11h-3" /></svg>
  );
}

export default SAVE1Icon;
